module.exports = " <div class=\"color-palette clearfix\" _v-5633701d=\"\"> <div class=\"palette-button color-palette-item\" data-cmd=setColor data-arg=\"{{ color }}\" v-for=\"(idx, color) in state.AVAILABLE_COLORS\" _v-5633701d=\"\"> <div class=color-fill v-bind:style=\"{ 'background-color': color }\" _v-5633701d=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5633701d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/palettes/SaveDialog.vue
// module id = 185
// module chunks = 2